export const HASURA_ENDPOINT = process.env.HASURA_ENDPOINT || '//hasura-staging.cowsquare.com/v1/graphql';
export const REGISTER_API_URL =
  process.env.REGISTER_API_URL ||
  'https://syoeiwmw3g.execute-api.us-east-1.amazonaws.com/dev/vontravel-register';
